// Passe une composition pour 100 g à l'échelle d'un poids en grammes. Même calcul que
// `api/src/macros.ts` (`scaleMacros`), recopié ici pour la même raison que `types.ts` : pas de code
// partagé entre les workspaces `web` et `api`. Contrairement au chemin modèle, le chemin
// code-barres connaît un poids ponctuel (saisi ou `serving_size`), pas une fourchette : un seul
// scalaire suffit ici, pas de `scaleMacrosRange`.
import type { MacrosPer100g } from './types.js';

function round(value: number, decimals: number): number {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}

export function scaleMacros(per100g: MacrosPer100g, poidsG: number): MacrosPer100g {
  if (!Number.isFinite(poidsG) || poidsG < 0) {
    throw new RangeError(`poidsG doit être un nombre positif ou nul (reçu ${poidsG})`);
  }
  const facteur = poidsG / 100;
  return {
    kcal: round(per100g.kcal * facteur, 0),
    glucides_g: round(per100g.glucides_g * facteur, 1),
    proteines_g: round(per100g.proteines_g * facteur, 1),
    lipides_g: round(per100g.lipides_g * facteur, 1),
    fibres_g: round(per100g.fibres_g * facteur, 1),
    sucres_g: round(per100g.sucres_g * facteur, 1),
    sel_g: round(per100g.sel_g * facteur, 2),
  };
}
